export default "__VITE_ASSET__c8332c56__"